import './styles/graphic.scss';
import * as d3 from 'd3';
import data from './data/coviddata.json';
import counties from './data/counties.json';
import states from './data/states.json';

const topojson = require('topojson-client');

const { countyData } = data;
const { reportDate } = data;

const path = d3.geoPath();

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;

  const map = container.append('div')
    .attr('id', 'map')
    .attr('class', 'map');

  const svg = map.append('svg')
    .attr('id', 'us-map')
    .attr('viewBox', '0 0 975 610');

  svg.append('g')
    .attr('class', 'counties')
    .selectAll('path')
    .data(topojson.feature(counties, counties.objects.counties).features)
    .join('path')
    .attr('fill', '#ccc')
    .attr('class', (d) => {
      const county = countyData.find(c => c.fips == d.id);
      if (county == undefined) {
        return 'county transmission-nodata';
      }
      return `county transmission-${county.transmission}`;
    })
    .attr('d', path);

  svg.append('g')
    .attr('class', 'states')
    .selectAll('path')
    .data(topojson.feature(states, states.objects.states).features)
    .join('path')
    .attr('fill', 'none')
    .attr('stroke', '#ffffff')
    .attr('stroke-width', '2px')
    .attr('d', path);


  container.append('p')
    .attr('class', 'meta')
    .text(`Note: Data reported on ${reportDate}`);
}
